import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "padlock",
  "use": "padlock-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"padlock\">\r\n    <path d=\"M23.99 14.06c0-2.47-.96-4.7-2.76-6.46a8.92 8.92 0 0 0-6.71-2.59C9.6 5.13 6 9.48 6 13.95v8.93A2.32 2.32 0 0 0 8.28 25h13.67c1.2 0 2.16-.94 2.04-2.12zm-8.16 4.71v2c0 .47-.36.82-.96.82-.59 0-.95-.35-.95-.82v-2a1.67 1.67 0 0 1-.84-2c.24-.71.96-1.29 1.79-1.29.84 0 1.68.58 1.8 1.29.12.7-.12 1.53-.84 2zm5.76-5.06s-.12.12-.24.12H8.64c-.12 0-.12 0-.24-.12v-.59a6.78 6.78 0 0 1 6.59-5.99c3.48.11 6.36 2.7 6.6 5.99.12.24 0 .36 0 .59z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol